import { http } from '@/http/axios.js';

export function getHomeStatAPI() {
  return http({
    url: '/admin/bi/home',
    method: 'get',
  })
}
